<template>
    <div>
        <h2 class="cms-content-heading cms-content-our-range__title">
            {{ title }}
        </h2>
        <slot></slot>

        <button
            v-on:click.prevent="openMobileFilters = !openMobileFilters"
            class="cms-content-our-range-filter__mobile-filter-btn cms-content-our-range-filter__button btn btn--full-width"
            :class="{ 'cms-content-our-range-filter__button--active': openMobileFilters }"
        >
            Filter
        </button>

        <div
            class="cms-content-our-range-filter__group"
            :class="{ 'cms-content-our-range-filter__group--open': openMobileFilters }"
        >
            <select-dropdown
                option-key="model"
                id="modelSelect"
                :event="{ category: 'New Model Search', label: 'Model Type Clicked' }"
            >
                Select model
            </select-dropdown>

            <select-dropdown
                option-key="type"
                id="typeSelect"
                :event="{ category: 'New Model Search', label: 'Vehicle Type Clicked' }"
            >
                Vehicle type
            </select-dropdown>

            <select-dropdown v-if="bodyStyle.length <= 0"
                option-key="bodystyle"
                id="bodySelect"
                :event="{ category: 'New Model Search', label: 'Body Type Clicked' }"
            >
                Body type
            </select-dropdown>

            <min-max-slider-dropdown
                id="budgetDropRange"
                min-key="minPrice"
                max-key="maxPrice"
                :step="500"
                :financial="true"
                v-if="initialized && showMinMaxSlider"
                :event="{ category: 'New Model Search', label: 'Budget Clicked' }"
            >
                Budget
            </min-max-slider-dropdown>

            <select-dropdown
                option-key="fuelType"
                id="fuelTypeSelect"
                :event="{ category: 'New Model Search', label: 'Fuel Type Clicked' }"
            >
                Fuel type
            </select-dropdown>

            <button
                v-on:click="openMobileFilters = false"
                class="cms-content-our-range-filter__filter-close btn btn--primary btn--full-width"
            >
                Search
            </button>
        </div>

        <LoadingSpinner v-if="loadingVehicles" />
        <template v-else-if="vehicles.length > 0">
            <div class="cms-content-our-range__card-container">
                <template v-for="(vehicle, index) in vehicles">
                    <vehicle-card  @match-height="handleMatchHeight" v-if="vehicle.coming_soon == 0" :vehicle="vehicle" :key="vehicle.id" :index="index" :hideResults="hideResults"/>
                    <vehicle-coming-soon v-else :vehicle="vehicle" :key="vehicle.id" :index="index" :hideResults="hideResults"/>
                </template>
            </div>
            <button
                v-on:click="toggleResults()"
                class="cms-content-our-range__show-all-vehicles btn btn--primary"
            >
                {{ !hideResults ? "Show less" : "Show more" }}
            </button>
        </template>
        <div class="cms-content-our-range__no-results" v-else>
            <span
                >Sorry, we have no results which match your options. Please
                <button
                    v-on:click="resetFilters"
                    class="cms-content-our-range__no-results-button"
                >
                    reset your filters
                </button>
                and try again.</span
            >
        </div>
        <div class="cms-content-trim-level__terms">
            <p class="terms">
                ^<span class="finance-terms__personal-quote"
                    >This is your personal quote, we will retain your deposit as you move
                    around the website.</span
                >
                Quotes are valid for a maximum of 14 days from {{ quoteValidDate }} and
                may be withdrawn without notice. Finance subject to status and age
                limitations. We may introduce you to a carefully selected group of finance
                providers.
                <strong>
                    Stellantis &You UK, is acting as a credit broker and not a lender and
                    will introduce you to a limited number of lenders.
                </strong>
                <a href="/terms-and-conditions" class="orange">* Ts and Cs apply.</a>
            </p>

            <p class="terms">Images for illustration purposes only</p>
        </div>
    </div>
</template>

<script>
import _debounce from 'lodash/debounce';
import SelectDropdown from "./SelectDropdown.vue";
import MinMaxSliderDropdown from "./MinMaxSliderDropdown.vue";
import VehicleCard from "./FinanceVehicleCard.vue";
import VehicleComingSoon from "./VehicleComingSoon.vue";
import { mapState } from "vuex";
import setupFinance from "../../../new-car-pages/modelIndex/finance";
import LoadingSpinner from '../../../used-vue/components/Buy-Online/LoadingSpinner.vue';
import { MatchHeight } from "js-match-height";

export default {
    components: {
        SelectDropdown,
        MinMaxSliderDropdown,
        VehicleCard,
        VehicleComingSoon,
        LoadingSpinner
    },
    props: {
        title: String,
        brand: String,
        bodyStyle: Array,
        useViewMoreButton: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            openMobileFilters: false,
            showMinMaxSlider: true,
            hideResults:false
        };
    },
    created() {
        this.hideResults = this.useViewMoreButton;
        this.$store.dispatch("updateOptions", {
            bodystyle: this.bodyStyle,
            brand: this.brand,
        });
    },
    computed: {
        ...mapState([
            'vehicles',
            'quoteValidDate',
            'loadingVehicles',
            'initialized',
            'availableOptions'
        ]),
    },
    watch: {
        vehicles: {
            deep: true,
            immediate: false,
            handler: function (newValue) {
                if (newValue.length <= 0) {
                    return;
                }
                this.$nextTick(function () {
                    new MatchHeight(".cms-content-our-range__card .cms-content-slice__trim-name", { timeout:400 });
                    setupFinance();
                });
            },
        },
    },
    methods: {
        toggleResults() {
            this.hideResults = !this.hideResults
            this.handleMatchHeight();
        },
        resetFilters() {
            this.showMinMaxSlider = false;
            this.$store.commit("updateOptions", {
                type: null,
                bodystyle: this.bodyStyle,
                minPrice: this.availableOptions.minPrice,
                maxPrice: this.availableOptions.maxPrice,
                fuelType: null,
            });
            this.$store.dispatch("getOptionsAndVehicles");
            this.$nextTick(function () {
                this.showMinMaxSlider = true;
            });
        },
        handleMatchHeight: _debounce(function () {
            $('.cms-content-our-range__available-electric').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false,
            });
        }, 50),
    },
};
</script>
